/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Col, Row, Tooltip } from 'antd';
import classNames from 'classnames';
import { isString } from 'lodash';
import React, { ReactElement, useMemo } from 'react';
import { GeneralFunction } from 'types/common';

import {
  ActionButtonContainer,
  CardStatus,
  MainTextStyled,
  UserInfoContainerStyled,
  UserInfoTextStyled,
} from './styled';

const CardBody: React.FC<{
  onDelete?: GeneralFunction;
  onEdit?: GeneralFunction;
  onRedirect?: GeneralFunction;
  main?: string | ReactElement;
  sub?: string | ReactElement;
  extra?: (string | ReactElement)[];
  status?: string;
  statusTooltipColor?: string;
  statusTooltip?: string;
  rightSide?: string | ReactElement;
}> = ({ onRedirect, onDelete, onEdit, main, sub, extra, status, statusTooltip, statusTooltipColor, rightSide }) => {
  const ActionTypeComponent = useMemo(() => {
    if (!onRedirect && !onEdit && !onDelete) return null;
    return (
      <>
        {onRedirect && (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div className='gx-dot-arrow' onClick={onRedirect}>
            <div className='gx-bg-primary gx-hover-arrow'>
              <i className='icon icon-long-arrow-right gx-text-white' />
            </div>
            <div className='gx-dot'>
              <i className='icon icon-ellipse-v gx-text-primary' />
            </div>
          </div>
        )}
        {onDelete && (
          <ActionButtonContainer
            style={{ width: 50 }}
            className='gx-dot gx-p-1 gx-mb-1'
            onClick={onDelete}
            $iconOnHoverColor='red'>
            <i className='icon icon-trash gx-text-grey' />
          </ActionButtonContainer>
        )}
        {onEdit && (
          <ActionButtonContainer
            style={{ width: 50 }}
            className='gx-dot gx-p-1'
            onClick={onEdit}
            $iconOnHoverColor='#038fde'>
            <i className='icon icon-edit gx-text-grey' />
          </ActionButtonContainer>
        )}
      </>
    );
  }, [onDelete, onEdit, onRedirect]);

  const userInfoContainerClass = classNames('user-wid-body gx-p-3');

  const generateExtraSection = (ex: any, i: number) => (
    <UserInfoTextStyled className='gx-mb-2 gx-text-grey' key={i} style={{ fontWeight: 14 }}>
      {ex}
    </UserInfoTextStyled>
  );

  return (
    <Row className='custom-card-body gx-w-100 gx-m-0 gx-flex-nowrap' style={{ overflow: 'hidden', flex: 1 }}>
      {(main || sub) && (
        <UserInfoContainerStyled className={`${userInfoContainerClass} custom-card-body-content`}>
          {main && (
            <div className='ant-row-flex'>
              {isString(main) ? (
                <UserInfoTextStyled className='gx-mr-1 gx-mb-1'>
                  <MainTextStyled className='max-lines'>{main}</MainTextStyled>
                </UserInfoTextStyled>
              ) : (
                main
              )}
            </div>
          )}
          {sub && (
            <div className='gx-mb-3 gx-text-grey' style={{ fontWeight: 14 }}>
              <div className='h4 gx-mr-1 gx-mb-1'>{sub}</div>
            </div>
          )}
          {extra && extra.map(generateExtraSection)}
        </UserInfoContainerStyled>
      )}
      {(status || ActionTypeComponent) && (
        <Row className='gx-pr-2' style={{ margin: 0, minWidth: 50, flex: 1 }} align='middle'>
          {status && (
            <Tooltip color={statusTooltipColor} placement='leftTop' title={statusTooltip}>
              <CardStatus $statusTooltipColor={statusTooltipColor} />
            </Tooltip>
          )}
          {ActionTypeComponent && (
            <Col className='gx-flex-column gx-align-items-end data-card-action-container' flex={1}>
              {ActionTypeComponent}
            </Col>
          )}
        </Row>
      )}
      {rightSide && <div className='gx-m-3 gx-ml-2 gx-flex-1 data-card-right-content-container'>{rightSide}</div>}
    </Row>
  );
};

export default React.memo(CardBody);
